export const DATA_SET_LIMIT = 1000;

export const ONE_HOUR_IN_MS = 60 * 1000;
